<div class="policy-admin-page">
  <div class="policy-admin-header">
    <div>
      <h1>Privacy Policy</h1>
      <p>Edit and publish the Navigator privacy policy wording.</p>
    </div>
    <button type="button" class="publish-btn" (click)="publish()" [disabled]="saving || loading">
      <i class="ri-upload-cloud-2-line"></i>
      {{ saving ? 'Publishing...' : 'Publish New Version' }}
    </button>
  </div>

  @if (message) {
    <div class="policy-message">{{ message }}</div>
  }

  @if (error) {
    <div class="policy-error">{{ error }}</div>
  }

  @if (loading) {
    <div class="policy-loading">
      <i class="ri-loader-4-line spin"></i>
      Loading...
    </div>
  }

  @if (!loading) {
    <div class="policy-grid">
      <section class="policy-editor">
        <div class="field">
          <label for="policy-title">Title</label>
          <input id="policy-title" type="text" [(ngModel)]="title" />
        </div>

        <div class="field field-content">
          <label for="policy-content">Policy Content</label>
          <p-editor
            id="policy-content"
            [(ngModel)]="contentHtml"
            [style]="{ height: '100%' }"
            placeholder="Enter privacy policy wording...">
            <ng-template #header>
              <span class="ql-formats">
                <button type="button" class="ql-bold" aria-label="Bold"></button>
                <button type="button" class="ql-italic" aria-label="Italic"></button>
                <button type="button" class="ql-underline" aria-label="Underline"></button>
                <button type="button" class="ql-strike" aria-label="Strikethrough"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color" aria-label="Text Color"></select>
                <select class="ql-background" aria-label="Background Color"></select>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" aria-label="Text Alignment"></select>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-link" aria-label="Insert Link"></button>
              </span>
              <span class="ql-formats">
                <button type="button" class="ql-clean" aria-label="Clear Formatting"></button>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </section>

      <section class="policy-preview">
        <div class="preview-header">
          <span>Preview</span>
          @if (currentPolicy) {
            <small>Current version {{ currentPolicy.versionNumber }}</small>
          }
        </div>
        <div class="preview-body ql-snow">
          <h2>{{ title }}</h2>
          <div class="ql-editor" [innerHTML]="previewHtml"></div>
        </div>
      </section>
    </div>
  }
</div>
